module.exports = __webpack_public_path__ + "static/media/olcatTam.111581cc.jpg";